import { useNavigate } from "react-router";

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="container text-center">
            <h2>404 - Sidan hittades inte</h2>
            <button className="btn btn-primary" onClick={() => navigate("/")}>
                Go till startsidan
            </button>
        </div>
    );
}
